import { Injectable } from '@angular/core';
import { AppError } from 'app/classes/app-error';
import { SyncLoggingService } from 'fitforce-logging';
import { DatabaseService, DatabaseServiceOptions, upgraded } from 'fitforce-offline-first';

const objectStores = {
  errors: { keyPath: 'key' },
  offlineErrors: { keyPath: 'key' },
};

@Injectable({
  providedIn: 'root',
})
export class UserDatabaseService extends DatabaseService {
  static version = 12;
  static dbName = 'fitforce-planner';

  public options: DatabaseServiceOptions;

  constructor(syncLog: SyncLoggingService) {
    super(syncLog);
    this.options = {
      dbName: UserDatabaseService.dbName,
      version: UserDatabaseService.version,
      objectStores: objectStores,
      seed: {},
      upgraded: upgraded,
    };
  }

  public clearDatabase(): Promise<any> {
    return Promise.all([
      this.clear(AppError),
    ]);
  }
}
